// extracted by mini-css-extract-plugin
export default {"backButton":"BookmarksHeader_backButton__cTBvs"};